import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import { isNativeApp } from '../../shared/native';
import {
  nativePermission,
  onNotificationTap,
  registerNativeDevice,
} from '../../shared/native-push';
import { useSession } from '../../shared/session';

/**
 * Native push op de achtergrond van de hele app-zone (MOB-1). Toont niets.
 *
 * Twee dingen, zolang iemand aangemeld is in de app:
 *
 * - **Een tik op een melding opent het juiste scherm**, ook als de app dicht was. De luisteraar
 *   hangt hier en niet op een pagina, want de melding kan om het even welk scherm openen.
 * - **Het toestel opnieuw aanmelden bij elke start**, als de toestemming er al is. Firebase kan het
 *   token vervangen (na een update, een herinstallatie, of zomaar), en een oud token betekent dat
 *   meldingen stil wegvallen. De vraag om toestemming zelf staat in de pushbalk en de
 *   instellingen, met uitleg ervoor: nooit hier, uit het niets.
 */
export function NativePush() {
  const router = useRouter();
  const { api, profile } = useSession();

  useEffect(() => {
    if (!isNativeApp()) return undefined;
    return onNotificationTap((path) => router.history.push(path));
  }, [router]);

  useEffect(() => {
    if (!isNativeApp() || !profile) return;
    void (async () => {
      try {
        if ((await nativePermission()) === 'granted') await registerNativeDevice(api);
      } catch {
        // Geen netwerk of Firebase niet ingesteld: de volgende start probeert het opnieuw.
      }
    })();
  }, [api, profile]);

  return null;
}
